import { render } from "./MessagePanel.vue?vue&type=template&id=342a6ba5&scoped=true"
import script from "./MessagePanel.vue?vue&type=script&lang=js"
export * from "./MessagePanel.vue?vue&type=script&lang=js"

import "./MessagePanel.vue?vue&type=style&index=0&id=342a6ba5&lang=less&scoped=true"

import exportComponent from "D:\\AIDA\\dlvip-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342a6ba5"]])

export default __exports__